import { render, staticRenderFns } from "./DdRadioSwitchTwoway.vue?vue&type=template&id=604f27ba&scoped=true&"
import script from "./DdRadioSwitchTwoway.vue?vue&type=script&lang=js&"
export * from "./DdRadioSwitchTwoway.vue?vue&type=script&lang=js&"
import style0 from "./DdRadioSwitchTwoway.vue?vue&type=style&index=0&id=604f27ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f27ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
